import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CampaignConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getEndpointOffer(): string {
		return this.service.get((x) => x.common.campaign.endpoints!.offer, "v1/campaignoffers/:offerId");
	}

	getEndpointOffers(): string {
		return this.service.get((x) => x.common.campaign.endpoints!.offers, "v1/campaignoffers");
	}

	getEndpointOfferEnrollments(): string {
		return this.service.get(
			(x) => x.common.campaign.endpoints!.offerEnrollments,
			"v1/campaignoffers/:offerId/enrollments"
		);
	}

	getEndpointCampaignEnrollments(): string {
		return this.service.get(
			(x) => x.common.campaign.endpoints!.campaignEnrollments,
			"v1/campaigns/:campaignCode/enrollments"
		);
	}

	getEndpointOptInCampaignEnrollments(): string {
		return this.service.get(
			(x) => x.common.campaign.endpoints!.optInEnrollments,
			"v1/campaignoffers/:campaignCode/enrollments"
		);
	}

	getCampaignCodeParamName(): string {
		return this.service.get((x) => x.common.campaign.campaignCodeParamName, "campaign");
	}

	getOptInParamName(): string {
		return this.service.get((x) => x.common.campaign.optInCodeParamName, "optin");
	}
}
